import React, { useEffect, useState } from "react";
import { Box, Button, Stack, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import GlobalWrapper from "../../../../../components/Wrapper/GlobalWrapper";
import { useLocation } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import GlobalDatagrid from "../../../../../components/mui/DataGrid/GlobalDatagrid";
import { Student_Attendace_Head } from "../../../../../components/datagrid/CRD/NewAdmissionRegister/StudentAttendanceTableHead";
import {
  getLedgerData,
  getStudentAttendanceView,
} from "../../../../../redux/features/CRDslice";
import { Ledger_Table_Head } from "../../../../../components/datagrid/CRD/NewAdmissionRegister/LedgerTableHead";
import { Icon } from "@iconify/react/dist/iconify.js";

const LedgerViewCro = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const admissionNo = searchParams.get("admissionNo");
  const studentName = searchParams.get("studentName");
  const course = searchParams.get("course");
  const courseEnrollmentId = searchParams.get("courseEnrollmentId");

  const dispatch = useDispatch();

  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const { loading, ledgerData } = useSelector((state) => state.crd);

  const [value, setValue] = useState(dayjs());
  const [rownum, setRownum] = useState(1);
  const MAX_ROWNUM = 5;

  const data = {
    course_enrollment_id: courseEnrollmentId,
    rownum: rownum,
  };

  useEffect(() => {
    dispatch(getLedgerData(data));
  }, [rownum]);

  const handlePrevious = () => {
    if (rownum < MAX_ROWNUM) {
      setRownum((prev) => prev + 1);
    }
  };

  const handleNext = () => {
    if (rownum > 1) {
      setRownum((prev) => prev - 1);
    }
  };

  const dispatchdata = data;

  const OpeningBalance = ledgerData[0]?.income_amount;

  const hasUnverifiedEntries = ledgerData?.some(
    (item) => item.accountant_verification === "0"
  );

  return (
    <GlobalWrapper title={"Ledger View"}>
      <Box sx={{ width: "100%", padding: 0 }}>
        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          spacing={1}
          paddingBottom={3}
        >
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#8FA6CB,#7D84B2)",
              px: "20px",
              py: "10px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "16px",
            }}
          >
            Admission No : {admissionNo}
          </Box>
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#8FA6CB,#7D84B2)",
              px: "20px",
              py: "10px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "16px",
            }}
          >
            Student Name : {studentName}
          </Box>
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#8FA6CB,#7D84B2)",
              px: "20px",
              py: "10px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "16px",
            }}
          >
            Course : {course}
          </Box>
          <Box
            sx={{
              backgroundImage: "linear-gradient(to right,#538083,#538083)",
              px: "20px",
              py: "10px",
              borderRadius: "15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "16px",
            }}
          >
            Course Enrollment ID : {courseEnrollmentId}
          </Box>
        </Stack>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: {
            xs: "flex-start",
            sm: "flex-end",
          },
          alignItems: "flex-start",
          paddingBottom: "10px",
          gap: "10px",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{ gap: "5px" }}
          onClick={handlePrevious}
          disabled={rownum >= MAX_ROWNUM}
        >
          <Icon icon="teenyicons:left-solid" width="13" height="13" /> Previous
        </Button>
        <Button
          variant="contained"
          color="primary"
          sx={{ gap: "5px" }}
          onClick={handleNext}
          disabled={rownum <= 1}
        >
          Next
          <Icon icon="teenyicons:right-solid" width="13" height="13" />
        </Button>
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Ledger_Table_Head(
            admissionNo,
            studentName,
            course,
            dispatchdata,
            OpeningBalance,
            hasUnverifiedEntries
          )}
          rows={ledgerData}
          meta={ledgerData?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="slNo"
          rowClick={false}
          actionComponent={<></>}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default LedgerViewCro;
